$(document).ready(function() {

// Custom sortby

$(document).on("click", ".cdk_facet_change_box:not(.active)", function () {
  $(".custom_facet_wrapper").slideUp();
  $(".cdk_select_facet").addClass("active");
  $(this).addClass("active");
  $(this).next(".custom_facet_wrapper").slideDown();
});

$(document).on("click", ".cdk_facet_change_box.active", function () {
  $('.cdk_facet_change_box').removeClass("active");
  $(".cdk_select_facet").removeClass("active");
  $(".custom_facet_wrapper").slideUp();
});

$(document).mouseup(function(e){
  var container = $(".custom_facet_wrapper");
  if(!container.is(e.target) && container.has(e.target).length === 0){
    $('.cdk_facet_change_box').removeClass("active");
    $(".cdk_select_facet").removeClass("active");
    $(".custom_facet_wrapper").slideUp();
  }
});

$(document).on("click", ".custom_facet .custom_facet_name", function () {
  var thisText = $(this).text();
  var facetChange = $(this).attr("value_change");
  console.log(facetChange);
  // console.log(thisText);
  $(this).parents(".custom_facet_wrapper").slideUp();
  $(this).parents(".cdk_select_facet").find(".cdk_selected_facet.desktop").text(thisText);
  $(".cdk_facet_change_box").removeClass('active');  
  $(this).parents(".cdk_select_facet").removeClass("active");
  $(".cdksortby select option[value='" +facetChange+ "']").attr('selected', 'selected');
  $(".cdksortby select").val(facetChange).change();
  $(".collection .loading-overlay").show();
  $(".custom_facet").removeClass("selected");
  $(this).parents(".custom_facet").addClass("selected");
});

// $(window).on('load',function(){
//  var selectedVal = $(".cdksortby select").find("option:selected").text();
//   console.log("selectedVal::"+selectedVal);
//   $('.cdk_selected_facet').text(selectedVal);
// });

// $(document).on("click", ".facets__disclosure .facets__list .facets__item .facet-checkbox", function () {
//   var selectedVal = $(".cdksortby select").find("option:selected").text();
//   console.log("selectedVal::"+selectedVal);
//   $('.cdk_selected_facet').text(selectedVal);
// });

$(document).on('change', '.cdksortby select', function() {
  var sortBy = $(this).val();
  var pageURL = $(location).attr("href");
 // Find the index of "sort_by="
  var startIndex = pageURL.indexOf("sort_by=");

  if (startIndex !== -1) {
  // Extract the text after "sort_by="
  var textAfterSortBy = pageURL.substring(startIndex + "sort_by=".length);

  // Remove the extracted text from the URL
  var modifiedURL = pageURL.replace(textAfterSortBy, "");
 var newUrl = modifiedURL+sortBy+'&';
  console.log("Modified URL: " + modifiedURL);
  }
  else if (document.URL.indexOf("search") > -1) { 
     var modifiedURL = pageURL;
    var newUrl = modifiedURL+'&sort_by='+sortBy+'&';
  }
  else {
     var modifiedURL = pageURL;
    var newUrl = modifiedURL+'?sort_by='+sortBy+'&';
  }
  console.log('newUr::'+newUrl)
  // Perform an AJAX request to fetch the sorted products.
  $.ajax({
    type: 'GET',
    url: newUrl,
    data: "html",
    success: function(data) {
      history.pushState('data', '', newUrl);
      var productListing = $(data).find('#product-grid .grid__item');
      $('#product-grid:not(.template-search__results)').html(productListing);
      $('#product-grid.template-search__results .product-grid').html(productListing);
      $(".collection .loading-overlay").hide();
    }
  });
});

// end sortby

    function youMayLikeCartSlider(){
      $('.cdk-slider').slick({
        dots: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll:1,
        prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="16" viewBox="0 0 48 16" fill="none"><path d="M0.292892 8.7071C-0.0976296 8.31658 -0.0976295 7.68341 0.292893 7.29289L6.65685 0.928929C7.04738 0.538404 7.68054 0.538404 8.07107 0.928929C8.46159 1.31945 8.46159 1.95262 8.07107 2.34314L2.41422 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68054 15.4616 7.04738 15.4616 6.65685 15.0711L0.292892 8.7071ZM48 9L1 9L1 7L48 7L48 9Z" fill="#369FC6"/></svg></button>',
        nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="16" viewBox="0 0 48 16" fill="none"><path d="M47.7071 8.7071C48.0976 8.31658 48.0976 7.68341 47.7071 7.29289L41.3431 0.928929C40.9526 0.538404 40.3195 0.538404 39.9289 0.928929C39.5384 1.31945 39.5384 1.95262 39.9289 2.34314L45.5858 8L39.9289 13.6569C39.5384 14.0474 39.5384 14.6805 39.9289 15.0711C40.3195 15.4616 40.9526 15.4616 41.3431 15.0711L47.7071 8.7071ZM8.74228e-08 9L47 9L47 7L-8.74228e-08 7L8.74228e-08 9Z" fill="#369FC6"/></svg></button>'
      
      });
    }
  
})
//Ajax Cart Count Function End

function updateMiniCart(currentThis) {
  $.ajax({
    type: "GET",
    url: "/",
    dataType: "html",

    success: function (data) {
      var miniCartHead = $(data).contents("#CartDrawer").find(".drawer__inner").html();
      $("#CartDrawer .drawer__inner").html(miniCartHead);
    },
  });
}

function ajaxAddToCartProduct(currentThis, dynamicData) {
  $.ajax({
    url: "/cart/add.js",
    type: "POST",
    data: { items: dynamicData },
    dataType: "json",
    success: function (data) {
      $(".loading-overlay__spinner").addClass("hidden");
      $(".cdk_custom_add .btn_text, .cdk-addToCart .btn_text").removeClass("hidden");
      $(".cdk_custom_add, .cdk-addToCart").removeClass("is-loading");
      // $('.grid__item .quick-view-wrapper').hide();
      updateMiniCart(currentThis);
      setTimeout(function () { 
        cartCount();
      },1000)
    },
    error: function (jqXHR, textStatus, errorThrown) {
      $(".loading-overlay__spinner").addClass("hidden");
      $(".cdk_custom_add, .cdk-addToCart").removeClass("is-loading");
      $(".cdk_custom_add .btn_text, .cdk-addToCart .btn_text").removeClass(
        "hidden"
      );
      if (jqXHR.status == 400) {
        alert(jqXHR.responseJSON.message);
      }
      if (jqXHR.status == 422) {
        alert(jqXHR.responseJSON.description);
      }
    },
  });
}

// function ajaxGiftProduct(variantId, quantity) {
//   eBook = {
//     id: variantId,
//     quantity: quantity 
//   };
//   $.ajax({
//     type: "GET",
//     url: "/cart/add.js",
//     data: eBook,
//     dataType: "json",
//     success: function () {
//         window.location = '/checkout;
//     },
//   });
// }

//Ajax Cart Count Function Start
function cartCount() {
  $.getJSON("/cart.js", function (cart) {
    $(".cart-count-bubble > span").html(cart.item_count);
    if (cart.item_count >= 1) {
      $("cart-drawer.cdesk-cart-drawer").removeClass("is-empty").addClass("active");
      $("body").addClass("overflow-hidden");
      $("#cart-icon-bubble").append('<div class="cart-count-bubble"><span aria-hidden="true">' +cart.item_count +'</span><span class="visually-hidden">' +cart.item_count +" items</span></div>"
      );
    }
  });
}


                                     
// quickwrapper
  $(document).on("click", ".cdk-selected-option:not(.active)", function () {
    $(".swatches-block-box").slideUp();
    $('.cdk-selected-option').removeClass("active");
    $(this).addClass("active");
    $(this).next(".swatches-block-box").slideDown();
  });
  $(document).on("click", ".cdk-selected-option.active", function () {
    $('.cdk-selected-option').removeClass("active");
    $(".swatches-block-box").slideUp();
  });
  $(document).on("click", ".swatches-block-box .swatches-option", function () {
    var thisText = $(this).text();
    $(this).parents(".swatches-block-box").slideUp();
    // $(this).next('.swatches-block-box').toggle();
    $(this).parents(".swatches-block").find(".cdk-selected-option .cdk-selected-option_item").text(thisText);
    $(this).parents(".swatches-block-box").prev('.cdk-selected-option').removeClass('active');
  });
  $(document).on("click",".product-card-wrapper .quick-view-wrapper .swatches-block .swatches-item-box .swatches-option",function () {
      var OptionName = $(this).attr("data-value");
      $(this).parents(".swatches-item-box").find(".swatches-option").removeClass("selected");
      $(this).addClass("selected");
      $(this).parents(".swatches-block").find("select").val(OptionName).change();
      // console.log("OptionName::" + OptionName);
  });
  $(document).on("change",".product-card-wrapper .quick-view-wrapper .swatches-block select.cdk-select",function () {
      var FinalValue = "";
      var thisParentId = $(this).parents(".product-card-wrapper .quick-view-wrapper").attr("data-id");
      // console.log('thisParentId::'+ thisParentId);
      // $('.product-card-wrapper .quick-view-wrapper[data-id="' + thisParentId + '"] .swatches-block').each(function () {
        var selectVal = $('.product-card-wrapper .quick-view-wrapper[data-id="' + thisParentId + '"] .swatches-block').find("select.cdk-select").val();
        // console.log('selectVal::'+selectVal);
        FinalValue += selectVal + " / ";
      // });
      var newstr = FinalValue.substring(0, FinalValue.length - 3);
      var optionName_Selector = $('.product-card-wrapper .quick-view-wrapper[data-id="' +thisParentId +'"] select.product_card-form__master-select option[check-data-sku="' +newstr +'"]');
      var optionName_val = optionName_Selector.val();
      // console.log('optionName_val::'+optionName_val);
      $('.product-card-wrapper .quick-view-wrapper[data-id="' +thisParentId +'"] select.product_card-form__master-select').val(optionName_val).change();
    });

  $(document).on("change",".product-card-wrapper .quick-view-wrapper select.product_card-form__master-select",function () {
      var thisMainVal = $(this).val();
      var thisParentId = $(this).parents(".product-card-wrapper .quick-view-wrapper").attr("data-id");
      // console.log("thisMainVal::" + thisMainVal);
      // console.log("thisParentId::" + thisParentId);
      var ThisProdAvail = $(this).find('option[value="' + thisMainVal + '"]').attr("data-varaint-availability");
      var ThisProdNP = $(this).find('option[value="' + thisMainVal + '"]').attr("data-price");
      var ThisProIMG = $(this).find('option[value="' + thisMainVal + '"]').attr("data-image");
      // console.log("ThisProIMG::" + ThisProIMG);
      $('.product-card-wrapper .quick-view-wrapper[data-id="' + thisParentId + '"]').find(".cdk_quick_price").find(".price-item").text(ThisProdNP);
      $('.product-card-wrapper .quick-view-wrapper[data-id="' + thisParentId + '"]').prev(".media").find("img").attr('src',ThisProIMG);
      $('.product-card-wrapper .quick-view-wrapper[data-id="' + thisParentId + '"]').prev(".media").find("img").attr('srcset',ThisProIMG);
      $('.product-card-wrapper .quick-view-wrapper[data-id="' + thisParentId + '"]').parents('.product-card-wrapper').find(".cdk_quick_price").find(".price-item").text(ThisProdNP);
      $('.cdk_custom_add[data-id="' + thisParentId + '"]').attr("data-variant",thisMainVal);         
        if (ThisProdAvail == "true") {
          $('.cdk_custom_add[data-id="' + thisParentId + '"]').attr("data-btn","addToCart");
          $('.cdk_custom_add[data-id="' + thisParentId + '"]').find(".btn_text").text("Add To Cart");
         
        } else {
          $('.cdk_custom_add[data-id="' + thisParentId + '"]').find(".btn_text").text("Sold Out");
          $('.cdk_custom_add[data-id="' + thisParentId + '"]').attr("data-btn","soldout");
        }
    });
    // $(window).resize(function(){  
    //     var thisMainVal = $(".product-card-wrapper .quick-view-wrapper select.product_card-form__master-select").val();
    //     var thisParentId = $(".product-card-wrapper .quick-view-wrapper select.product_card-form__master-select").parents(".product-card-wrapper .quick-view-wrapper").attr("data-id");
    //     var ThisProdAvail = $(".product-card-wrapper .quick-view-wrapper select.product_card-form__master-select").find('option[value="' + thisMainVal + '"]').attr("data-varaint-availability");
    //     if ($(window).width() < 768) {
    //       $('.cdk_custom_add[data-id="' + thisParentId + '"]').find(".btn_text").text("Add");        
    //     }
    //     else {
    //       $('.cdk_custom_add[data-id="' + thisParentId + '"]').find(".btn_text").text("Add To Cart");
    //     }
    // });
// cart drawer start
$(document).on("click",".cart-product-wrapper .quick-view-wrapper .swatches-block .swatches-item-box .swatches-option",function () {
  var OptionName = $(this).attr("data-value");
  $(this).parents(".swatches-item-box").find(".swatches-option").removeClass("selected");
  $(this).addClass("selected");
  $(this).parents(".swatches-block").find("select").val(OptionName).change();
  console.log("OptionName::" + OptionName);
});

$(document).on("change",".cart-product-wrapper .quick-view-wrapper .swatches-block select.cdk-select",function () {
  var FinalValue = "";
  var thisParentId = $(this).parents(".cart-product-wrapper .quick-view-wrapper").attr("data-id");
  console.log('thisParentId::'+ thisParentId);
  // $('.cdk-product-wrapper .quick-view-wrapper[data-id="' + thisParentId + '"] .swatches-block').each(function () {
    var selectVal = $('.cart-product-wrapper .quick-view-wrapper[data-id="' + thisParentId + '"] .swatches-block').find("select.cdk-select").val();
    // console.log('selectVal::'+selectVal);
    FinalValue += selectVal + " / ";
  // });
  var newstr = FinalValue.substring(0, FinalValue.length - 3);
  var optionName_Selector = $('.cart-product-wrapper .quick-view-wrapper[data-id="' +thisParentId +'"] select.product_card-form__master-select option[check-data-sku="' +newstr +'"]');
  var optionName_val = optionName_Selector.val();
  // console.log('optionName_val::'+ optionName_val);
  $('.cart-product-wrapper .quick-view-wrapper[data-id="' +thisParentId +'"] select.product_card-form__master-select').val(optionName_val).change();
});
$(document).on("change",".cart-product-wrapper .quick-view-wrapper select.product_card-form__master-select",function () {
  var thisMainVal = $(this).val();
  var thisParentId = $(this).parents(".cart-product-wrapper .quick-view-wrapper").attr("data-id");
  // console.log("thisMainVal::" + thisMainVal);
  // console.log("thisParentId::" + thisParentId);
  var ThisProdAvail = $(this).find('option[value="' + thisMainVal + '"]').attr("data-varaint-availability");
  var ThisProdNP = $(this).find('option[value="' + thisMainVal + '"]').attr("data-price");
  // console.log("ThisProdNP::" + ThisProdNP);
  $('.cart-product-wrapper .quick-view-wrapper[data-id="' + thisParentId + '"]').find(".cdk_quick_price").find(".price-item").text(ThisProdNP);
  $('.cdk_custom_add[data-id="' + thisParentId + '"]').attr("data-variant",thisMainVal);
  if (ThisProdAvail == "true") {
    $('.cdk_custom_add[data-id="' + thisParentId + '"]').attr("data-btn","addToCart");
    $('.cdk_custom_add[data-id="' + thisParentId + '"]').find(".btn_text").text("Add");
  } else {
    $('.cdk_custom_add[data-id="' + thisParentId + '"]').find(".btn_text").text("Sold Out");
    $('.cdk_custom_add[data-id="' + thisParentId + '"]').attr("data-btn","soldout");
  }
});
// cart drawer end
// Complimentry product start
$(document).on("click",".complimentry-product-wrapper .quick-view-wrapper .swatches-block .swatches-item-box .swatches-option",function () {
  var OptionName = $(this).attr("data-value");
  $(this).parents(".swatches-item-box").find(".swatches-option").removeClass("selected");
  $(this).addClass("selected");
  $(this).parents(".swatches-block").find("select").val(OptionName).change();
  console.log("OptionName::" + OptionName);
});

$(document).on("change",".complimentry-product-wrapper .quick-view-wrapper .swatches-block select.cdk-select",function () {
  var FinalValue = "";
  var thisParentId = $(this).parents(".complimentry-product-wrapper .quick-view-wrapper").attr("data-id");
  console.log('thisParentId::'+ thisParentId);
  // $('.cdk-product-wrapper .quick-view-wrapper[data-id="' + thisParentId + '"] .swatches-block').each(function () {
    var selectVal = $('.complimentry-product-wrapper .quick-view-wrapper[data-id="' + thisParentId + '"] .swatches-block').find("select.cdk-select").val();
    // console.log('selectVal::'+selectVal);
    FinalValue += selectVal + " / ";
  // });
  var newstr = FinalValue.substring(0, FinalValue.length - 3);
  var optionName_Selector = $('.complimentry-product-wrapper .quick-view-wrapper[data-id="' +thisParentId +'"] select.product_card-form__master-select option[check-data-sku="' +newstr +'"]');
  var optionName_val = optionName_Selector.val();
  // console.log('optionName_val::'+ optionName_val);
  $('.complimentry-product-wrapper .quick-view-wrapper[data-id="' +thisParentId +'"] select.product_card-form__master-select').val(optionName_val).change();
});
$(document).on("change",".complimentry-product-wrapper .quick-view-wrapper select.product_card-form__master-select",function () {
  var thisMainVal = $(this).val();
  var thisParentId = $(this).parents(".complimentry-product-wrapper .quick-view-wrapper").attr("data-id");
  // console.log("thisMainVal::" + thisMainVal);
  // console.log("thisParentId::" + thisParentId);
  var ThisProdAvail = $(this).find('option[value="' + thisMainVal + '"]').attr("data-varaint-availability");
  var ThisProdNP = $(this).find('option[value="' + thisMainVal + '"]').attr("data-price");
  // console.log("ThisProdNP::" + ThisProdNP);
  $('.complimentry-product-wrapper .quick-view-wrapper[data-id="' + thisParentId + '"]').find(".cdk_quick_price").find(".price-item").text(ThisProdNP);
  $('.cdk_custom_add[data-id="' + thisParentId + '"]').attr("data-variant",thisMainVal);
  if (ThisProdAvail == "true") {
    $('.cdk_custom_add[data-id="' + thisParentId + '"]').attr("data-btn","addToCart");
    $('.cdk_custom_add[data-id="' + thisParentId + '"]').find(".btn_text").text("Add");
  } else {
    $('.cdk_custom_add[data-id="' + thisParentId + '"]').find(".btn_text").text("Sold Out");
    $('.cdk_custom_add[data-id="' + thisParentId + '"]').attr("data-btn","soldout");
  }
});
// Complimentry product end

// end quickwrapper
$(document).on("click",'.cdk_custom_add.freeGiftProduct[data-btn="addToCart"], .cdk-addToCart.freeGiftProduct',function (e) {
  e.preventDefault();
  var currentThis = $(this);
  var updateItems = [];
  var variantId = $(this).attr("data-variant");
  var variantId_1 = 32906998972547;
  var quantity = 1;
  var productIdToCheck = 4719828074627;
  var productExistsInCart = false;
  $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
              updateItems.push({ id: variantId, quantity: quantity });
                ajaxAddToCartProduct(currentThis, updateItems);
                currentThis.addClass("is-loading");
                currentThis.find(".loading-overlay__spinner").removeClass("hidden");
                currentThis.find(".btn_text").addClass("hidden");
                $('.cdesk-cart-drawer').addClass('cdkCart-wrapper');
                setTimeout(function () {   
                  $('.cdk-slider').slick({
                    dots: true,
                    infinite: false,
                    slidesToShow: 1,
                    slidesToScroll:1,
                    prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="16" viewBox="0 0 48 16" fill="none"><path d="M0.292892 8.7071C-0.0976296 8.31658 -0.0976295 7.68341 0.292893 7.29289L6.65685 0.928929C7.04738 0.538404 7.68054 0.538404 8.07107 0.928929C8.46159 1.31945 8.46159 1.95262 8.07107 2.34314L2.41422 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68054 15.4616 7.04738 15.4616 6.65685 15.0711L0.292892 8.7071ZM48 9L1 9L1 7L48 7L48 9Z" fill="#369FC6"/></svg></button>',
                    nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="16" viewBox="0 0 48 16" fill="none"><path d="M47.7071 8.7071C48.0976 8.31658 48.0976 7.68341 47.7071 7.29289L41.3431 0.928929C40.9526 0.538404 40.3195 0.538404 39.9289 0.928929C39.5384 1.31945 39.5384 1.95262 39.9289 2.34314L45.5858 8L39.9289 13.6569C39.5384 14.0474 39.5384 14.6805 39.9289 15.0711C40.3195 15.4616 40.9526 15.4616 41.3431 15.0711L47.7071 8.7071ZM8.74228e-08 9L47 9L47 7L-8.74228e-08 7L8.74228e-08 9Z" fill="#369FC6"/></svg></button>'
                  
                  });
                },2500);
        }
      });
  
});

// Product sticky bar
 $(document).on("click",".product-sticky-wrapper .swatches-block .swatches-item-box .swatches-option",function () {
    var OptionName = $(this).attr("data-value");
    $(this).parents(".swatches-item-box").find(".swatches-option").removeClass("selected");
    $(this).addClass("selected");
    $(this).parents(".swatches-block").find("select").val(OptionName).change();
    // console.log("OptionName::" + OptionName);
   // $(".product-form__input input[type=radio]").attr("checked",false);
   // $(".product-form__input input[type=radio][value='" +OptionName+ "']").attr("checked",true);   
   // $(".product-form__input input[type=radio][value='" +OptionName+ "']").next().click();
});
  $(document).on("change",".product-sticky-wrapper  .swatches-block select.cdk-select",function () {
    var FinalValue = "";
    // var thisParentId = $(this).parents(".product-card-wrapper .quick-view-wrapper").attr("data-id");
    // console.log('thisParentId::'+ thisParentId);
    var selectVal = $(this).val();
    // console.log('selectVal::'+selectVal);
    FinalValue += selectVal + " / ";
    var newstr = FinalValue.substring(0, FinalValue.length - 3);
    var optionName_Selector = $('.product-sticky-wrapper select.product_card-form__master-select option[check-data-sku="' +newstr +'"]');
    var optionName_val = optionName_Selector.val();
    $('.product-sticky-wrapper select.product_card-form__master-select').val(optionName_val).change();
  });

  $(document).on("change",".product-sticky-wrapper select.product_card-form__master-select",function () {
      var thisMainVal = $(this).val();
      // var thisParentId = $(this).parents(".product-card-wrapper .quick-view-wrapper").attr("data-id");
      // console.log("thisMainVal::" + thisMainVal);
      // console.log("thisParentId::" + thisParentId);
      var ThisProdAvail = $(this).find('option[value="' + thisMainVal + '"]').attr("data-varaint-availability");
      var ThisProdNP = $(this).find('option[value="' + thisMainVal + '"]').attr("data-price");
     // console.log("ThisProdAvail::" + ThisProdAvail);
     //  console.log("ThisProdNP::" + ThisProdNP);
      $(this).parents('.product-sticky-wrapper').find(".cdk_quick_price").find(".price-item.price-item--regular").text(ThisProdNP);
      $('.cdk_custom_add').attr("data-variant",thisMainVal);
      if (ThisProdAvail == "true") {
        $('.cdk_custom_add').attr("data-btn","addToCart");
        $('.cdk_custom_add').find(".btn_text").text("Add To Cart");
      } else {
        $('.cdk_custom_add').find(".btn_text").text("Sold Out");
        $('.cdk_custom_add').attr("data-btn","soldout");
      }
    });
    // $("input.product-variant-id").change(function () {
    //   console.log("varid::" + $(this).val());
    //   var vari_Id = $(this).val();
    //   var jsonText = $("script[data-product-inventory-json]").html();
    //   var jsonData = JSON.parse(jsonText);
    //   var variantData = jsonData.variant;
    //   var value = variantData[vari_Id];
    //   //console.log("Reg value::" + value.rprice);
    //   //console.log("Comp value::" + value.cprice);
    //   $(".cdkStickyPrice").find(".cdk_quick_price").find(".price-item--regular").text(value.rprice);
    //   $(".cdkStickyPrice").find(".cdk_quick_price").find(".price__sale").text(value.cprice);
    //   $(".product-sticky-wrapper .swatches-block").find("select").val(vari_Id).change();
    // });
    //  $(document).on("click","fieldset.product-form__input label",function () {
    //   var stickyOptionChange = $(this).prev().val();
    //   $(".product-sticky-wrapper .swatches-block").find("select").val(stickyOptionChange).change();
    //   $(".product-sticky-wrapper .cdk-selected-option_item").text(stickyOptionChange);
    // });

    $(document).on("click","fieldset.product-form__input label",function () {
      var stickyOptionChange = $(this).prev().val();
      $(".product-sticky-wrapper .swatches-block").find("select").val(stickyOptionChange).change();
      $(".product-sticky-wrapper .cdk-selected-option_item").text(stickyOptionChange);
    });

  




$( document ).ready(function() { 
  // video list
  $(document).on("click", ".cover_image .video-play", function () {
    $(this).parents(".cover-img-video").find("video").trigger("play");
    $(this).parents(".cover-img-video").find(".cover_image").hide();
    $(this).parents(".video").siblings().find(".cover-img-video video").trigger("pause");
    $(this).parents(".video").siblings().find(".cover-img-video .cover_image").show();
  });
  $(".video .video-sound").click(function (e) {
    var VideoSoundD = $(this).parents(".cover-img-video").find("video");
    if (VideoSoundD.prop("muted", true)) {
      VideoSoundD.prop("muted", false);
    } else VideoSoundD.prop("muted", false);
    {
      VideoSoundD.prop("muted", true);
    }
  });

  //end video list
  
  
  
  $("button").click(function() {
    $(".popup").fadeIn(500);
  });
  $(".close").click(function() {
    $(".popup").fadeOut(500);
  });
  
  // $(document).on("click" , '.product-tabs-items li', function(){
  //   var scrolldiv = $(this).attr("data-target");
  //   // console.log("show::"+scrolldiv)
  //   // $("#description_span[data_show='" +scrolldiv+ "']").show();
  //   $(".product-description-tabs").addClass("active");
  //   $("body,html").addClass("overflow-hidden");
  //   // $('.product-description-bg').animate({
  //   //       scrollTop: $(".description_span[data_show='" +scrolldiv+ "']").offset().top
  //   // }, 0);
  // });

  // $(document).on("click", '.product-tabs-items li', function() {
  //     var target = $(this).attr('data-target');
  //     console.log('target::' + target);
  //     $(".product-description-tabs").addClass("active");
      
  //     Calculate the target position relative to the popup content area
  //     var targetPosition = $('#' + target).position().top - 30;
  
  //     Animate the scroll within the popup content area
  //     setTimeout(function () {
  //       $('.product-description-bg').animate({
  //           scrollTop: targetPosition
  //       }, 1000); 
  //     },1000)
  // });
  
  
  
  $(document).on("click", ".forgot-ps", function () {
    $(".cdk-login-section").addClass('rest-password');
    $(".create_account_main").hide();
    $("h2.cdk-login-title").hide();
  });
  $(document).on("click", ".cancel-reset-pass", function () { 
    $(".cdk-login-section").removeClass('rest-password');
    $(".create_account_main").show();
    $("h2.cdk-login-title").show();
  });
  var currentUrl = window.location.href;
  var staticUrl = 'https://igluumealprep.com/account/login#recover'
  // console.log("currentUrl::"+ currentUrl);
  if (currentUrl == staticUrl){
     $(".cdk-login-section").addClass('rest-password');
    $("h2.cdk-login-title").hide();
    $(".create_account_main").hide();
  }
  
  

    $(document).on("click", "summary.menu-drawer__menu-item", function () {
      $("header.header").addClass("menu_item_open");
    });

    $(document).on("click", ".menu-drawer__close-button", function () {
      if ($("ul.menu-drawer__menu").hasClass("submenu-open")) {
        $("header.header").addClass("menu_item_open");
      }
      if (!$("ul.menu-drawer__menu").hasClass("submenu-open")) {
        $("header.header").removeClass("menu_item_open");
      }
    });

  // FAQ
  $(document).on('click', '.faq-ques', function(){
     $(this).parents('.content').siblings('.content').find('.faq-content .faq-ques').removeClass('active');
     $(this).parents('.content').siblings('.content').find('.faq-content .faq-ans').slideUp();
     $(this).toggleClass('active');
     $(this).parents('.content').find('.faq-content .faq-ans').slideToggle();
    });
  
    $(document).on('click', '.clearSearch', function(){
      var searcvalue = $('#faqsearch').val().toLowerCase();
      console.log(searcvalue);
      $('#faqsearch').val("");
      $('.no-results').hide();
      $(".content").show();
       $(".searchContent").show();
    });
  
     var $block = $('.no-results');
      var $container = $('.searchContent');
    
    $("#faqsearch").keyup(function() {
        var $length = 0;
        var val = $(this).val().toLowerCase();
        var isMatch = false;
      $(".searchContent").each(function(i) {
        var $length = 0;
          $(this).find(".faq-content").each(function(i) {
              var content = $(this).html();
              if(content.toLowerCase().indexOf(val) == -1) {
                 $(this).parents('.content').hide();
                // $(this).parent('.content').prev('.heading').hide();
              
              } else {
                  isMatch = true;
                  $(this).parents('.content').show();
                 // $(this).parent('.content').prev('.heading').show();
                $length += 1;
              }
          });
        if($length  == 0){
          $(this).hide();
        }else{
          $(this).show();
        }
            // console.log('this length::'+$length);
        });
      
        
   
      $block.toggle(!isMatch);
    });
    // End faq

    $(document).on('click', '.menu_drawer_close', function(){
        console.log("click")
       $(this).parents(".menu-drawer-container[open]").find(".header__icon--menu").click();
    });
  
    $(document).on('click', '.password_toggle_btn', function(){
      var x = $(this).prev(".password_toggle").attr('type');
      $(this).toggleClass("active");
      if (x == "password") {
        $(this).prev(".password_toggle").attr("type", "text");
      } else {
        $(this).prev(".password_toggle").attr("type", "password");
      }
    })
  $(document).on('click', '.mega_menu .mega-menu .header__menu-item' ,function(e){
    e.preventDefault();
  })
    $(".mega-menu").mouseenter(function(){
      
      $(this).attr("open", true);
      $('body').addClass('overflow-hidden');
      $('.cdk-overlay').addClass('active');
    });
    $(".mega-menu").mouseleave(function(){
      $(this).attr("open", false);
      $('body').removeClass('overflow-hidden');
       $('.cdk-overlay').removeClass('active');
    });
    $('.product-form__submit.freeGiftProduct').on('click', function(e) {
      e.preventDefault();
      $(this).addClass("loading");
      $(this).find(".loading-overlay__spinner").removeClass("hidden");
      $(this).find(".btn_text").addClass("hidden");
      $(this).prop('disabled', true);
      var productIdToCheck = 4719828074627;
      var productExistsInCart = false;
      
      
      var currentThis = $(this);
      var updateItems = [];      
      var variantId = $(this).parents('.product-form').find('.gift-product-variant-id').val();
      var variantId2 = $(this).parents('.product-form').find('.product-variant-id').val();
      var quantity = 1;
      setTimeout(function () {
        $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
          updateItems.push({ id: variantId2, quantity: quantity });
                ajaxAddToCartProduct(currentThis, updateItems);
                currentThis.removeClass("loading");
                currentThis.find(".loading-overlay__spinner").addClass("hidden");
                currentThis.find(".btn_text").removeClass("hidden");
                currentThis.removeAttr("disabled");
        }
      });
      },300)
      
      
    
    });
    $(".business_wrapper h3").click(function(){
      $(".business_wrapper .form-radio-input").toggle();
      $(".business_wrapper h3").toggleClass("active");
    });
    // cart redirect
    // Define the URL pattern to match
    // var patternToMatch = '/cart'; // Replace with the URL you want to match
  
    // // Check if the current URL matches the pattern
    // if (window.location.pathname === patternToMatch) {
    //   // Redirect to the new URL
    //   window.location.href = '/'; // Replace with the URL to redirect to
    // }
    // end cart redirect  
    
    // if ($(".mobile-facets__main").find("details").length > 0) {
    //   $(".mobile-facets__main").parents(".mobile-facets__wrapper").removeClass("remove_filter");
    // } else {
    //   $(".mobile-facets__main").parents(".mobile-facets__wrapper").addClass("remove_filter");
    // }
  
    // Product tab popup scroll
    $('.product-tabs-items li').on('click', 'a[href^="#"]', function(e) {
    $(".product-description-tabs").addClass("active");
    $(".overlay").addClass("active");
      $("body,html").addClass("tab_overflow");
      // target element id
      var id = $(this).attr('href');
    
      // target element
      var $id = $(id);
      if ($id.length === 0) {
          return;
      }
    
      // prevent standard hash navigation (avoid blinking in IE)
      e.preventDefault();
      
      // top position relative to the document
      var pos = $id.offset().top;
      console.log('pos::'+pos);
      // animated top scrolling
    $('.product-description-tabs').animate({scrollTop: pos}, 500);
  });

  $(document).on("click" , '.product-tabs-close-btn', function(){
    $(".product-description-tabs").removeClass("active");
     $(".overlay").removeClass("active");
    $("body,html").removeClass("tab_overflow");
    $(".product-description-tabs").animate({ scrollTop: "0" }); 
  });
  
  $(document).mouseup(function(ee){
    var container = $(".product-description-tabs");
    if(!container.is(ee.target) && container.has(ee.target).length === 0){
      $(".product-description-tabs").removeClass("active");
      $(".overlay").removeClass("active");
      $("body,html").removeClass("tab_overflow");
      $(".product-description-tabs").animate({ scrollTop: "0" });      
      //   $('.product-tabs-content').removeClass("test");
    }
  });
    $(document).on('click', '.cart_drawer_scroll #Details-CartDrawer summary' ,function(){
      $ ('.cart_drawer_scroll') .animate ({
        scrollTop: $(".cart_drawer_scroll").get(0).scrollHeight
        }, 2000);
    })

  $(document).on("click" , '.products_tabs_desktop .tab_heading', function(){
    var productTab = $(this).attr("tabname");
    console.log(productTab);
    $(this).siblings().removeClass("active");
    $(".tab_content .tab-description").hide();
    $(".tab_content .tab-description").removeClass("active");
    $(this).addClass("active");
    $(".products_tabs").show();
    $(".tab_content .tab-description[tabfor='" +productTab+ "']").show();
    $(".tab_content .tab-description[tabfor='" +productTab+ "']").addClass("active");
    $('html,body').animate({
        scrollTop: $(".tab_content .tab-description[tabfor='" +productTab+ "']").offset().top - 125
    }, 0); 
  });
  
});


// Retrieve the value from local storage
var retrievedData = localStorage.getItem("myLocation"); 
if (retrievedData == 'GB') {
  
}else{
  $('.cdesk-cart-drawer .cart-drawer__footer .free-shipping-main').hide();
}

if (retrievedData) {
    // Data exists in local storage
} else {
    // Data doesn't exist in local storage
   $.getJSON("https://ipgeolocation.abstractapi.com/v1/?api_key=6d45144047af4df595316681a44b682e", function(data) {
       var location = data.country_code;
       localStorage.setItem("myLocation", location); 
     if(location == 'GB'){
       $('.cdesk-cart-drawer .cart-drawer__footer .free-shipping-main').show();
     }else{
       $('.cdesk-cart-drawer .cart-drawer__footer .free-shipping-main').hide();
     }
    });
}

$(document).mouseup(function(evnt){
  var container2 = $(".swatches-block-box");
  if(!container2.is(evnt.target) && container2.has(evnt.target).length === 0){
    $('.cdk-selected-option').removeClass("active");
    $(".swatches-block-box").hide();
  }
});



window.addEventListener("klaviyoForms", function(e) { 
    if (e.detail.type == 'submit') {
        // Get the reference to the element with the ID 'wholesale-enquiry'
        var wholesaleEnquiryDiv = document.getElementById('wholesale-enquiry');
        
        // Check if the element exists
        if (wholesaleEnquiryDiv) {
          // Scroll to the 'wholesale-enquiry' div
          wholesaleEnquiryDiv.scrollIntoView({
            behavior: 'smooth', // Optional: Adds smooth scrolling behavior
            block: 'start'      // Optional: Scrolls to the start of the element
          });
        }
    }
});

$(document).on("click" , 'variant-radios .product-form__input input', function(){
  setTimeout(function () { 
      location.reload();
  },100)
});